var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.773 2.55529C10.9136 2.69593 10.9926 2.88667 10.9926 3.08554C10.9926 3.28441 10.9136 3.47514 10.773 3.61579L5.15151 9.23729C5.07722 9.3116 4.98902 9.37054 4.89195 9.41075C4.79488 9.45097 4.69084 9.47167 4.58576 9.47167C4.48069 9.47167 4.37665 9.45097 4.27957 9.41075C4.1825 9.37054 4.0943 9.3116 4.02001 9.23729L1.22701 6.44479C1.15538 6.3756 1.09824 6.29285 1.05894 6.20134C1.01963 6.10984 0.998941 6.01142 0.998075 5.91184C0.99721 5.81226 1.01619 5.7135 1.0539 5.62132C1.09161 5.52915 1.1473 5.44541 1.21772 5.37499C1.28814 5.30457 1.37188 5.24888 1.46405 5.21117C1.55622 5.17346 1.65498 5.15449 1.75456 5.15535C1.85415 5.15622 1.95256 5.17691 2.04407 5.21621C2.13557 5.25552 2.21833 5.31266 2.28751 5.38429L4.58551 7.68229L9.71201 2.55529C9.78166 2.48559 9.86436 2.43031 9.95539 2.39259C10.0464 2.35486 10.144 2.33545 10.2425 2.33545C10.341 2.33545 10.4386 2.35486 10.5296 2.39259C10.6207 2.43031 10.7034 2.48559 10.773 2.55529Z",
    fill: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4ab650fea6e756dd923ae9f22318874e.svg";
export { ForwardRef as ReactComponent };